const TRACKING_SERVICE_URL =
  import.meta.env.VITE_TRACKING_SERVICE_URL ||
  "https://api.clynox.com";

export default TRACKING_SERVICE_URL;

/**
 * Returns the WebSocket URL for the tracking service.
 * When a JWT token is provided it is appended as ?token=<jwt> so the
 * server can authenticate the upgrade request.
 * @param {string|null} token - JWT access token from auth storage
 */
export const getWebSocketUrl = (token) => {
  const base =
    import.meta.env.VITE_TRACKING_WS_URL ||
    "wss://api.clynox.com/ws";
  if (!token) return base;
  return `${base}?token=${encodeURIComponent(token)}`;
};